import { ReactNode } from "react";
import classNames from "classnames";

import Icons from "assets";
import { useSidebar } from "./sidebar-context";

export type SidebarMenuHeaderProps = {
  logo: ReactNode;
  collapsedLogo: ReactNode;
};

const SidebarMenuHeader = ({ logo, collapsedLogo }: SidebarMenuHeaderProps) => {
  const { isCollapsed, onToggleCollapse } = useSidebar();

  return (
    <div
      className={classNames("relative flex h-16 items-center py-2 transition-all duration-200", {
        "px-3": isCollapsed,
        "pl-7 pr-6": !isCollapsed,
      })}>
      <div
        aria-hidden={isCollapsed}
        className={classNames("flex items-center transition-all duration-200 overflow-hidden", {
          "max-w-36 opacity-100": !isCollapsed,
          "max-w-0 opacity-0": isCollapsed,
        })}>
        {logo}
      </div>

      <div
        aria-hidden={!isCollapsed}
        className={classNames(
          "absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center transition-all duration-200",
          {
            "opacity-100": isCollapsed,
            "opacity-0 pointer-events-none": !isCollapsed,
          },
        )}>
        {collapsedLogo}
      </div>

      <button
        type="button"
        onClick={onToggleCollapse}
        className={classNames(
          "absolute top-1/2 z-50 size-6 flex -translate-y-1/2 items-center justify-center rounded-full text-gray-500 transition-all duration-200 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-aqua-600 focus-visible:ring-offset-2",
          isCollapsed
            ? "-right-3 border border-gray-200 bg-white shadow-xs"
            : "right-4 bg-transparent",
        )}
        aria-label={isCollapsed ? "Expand side menu" : "Collapse side menu"}>
        <Icons.DoubleChevron
          className={classNames("transition-transform", { "rotate-180": !isCollapsed })}
        />
      </button>
    </div>
  );
};

export default SidebarMenuHeader;
